function checkNavOverflow() {
    const nav = document.querySelector('.nav_wrap_bottom-links');
    const gradient = document.querySelector('.nav_gradient_if-too-many-links');
    if (!nav || !gradient) return;

    gradient.style.display = nav.scrollWidth > nav.clientWidth ? 'block' : 'none';
}

checkNavOverflow();
window.addEventListener('resize', checkNavOverflow);
